import React, { FC, useState } from 'react'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import FhirLoader from '../../../components/FhirLoader'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PasswordInput from '../../../components/PasswordInput'
import { Link } from 'react-router-dom'
import { appConfig } from '../../../assets/customizations/config'

type LoginFormProps = {
  formHandler: any;
  alertState: { show: boolean; variant: string; message: string; };
  closeAlert: () => void;
  openForgotModal: (type: string) => void;
  isLoading: boolean;
}

const LoginForm: FC<LoginFormProps> = ({ formHandler, alertState, closeAlert, openForgotModal, isLoading }) => {
  const [showPassword, setShowPassword] = useState(false)
  const loginLabel = appConfig.custom_login_label || 'Log In'

  return (
    <>
      <h2 className='headerText h3'>{loginLabel}</h2>
      <Form noValidate onSubmit={formHandler.handleSubmit} id='login'>
        {
          alertState.show && (
            <Alert variant={alertState.variant} dismissible onClose={closeAlert}>
              {alertState.message}
            </Alert>
          )
        }
        <Form.Group className='custom'>
          <Form.Label>
            Username:
          </Form.Label>
          <Form.Control
            type='text'
            placeholder='Enter Username'
            name='username'
            value={formHandler.values.username}
            onChange={formHandler.handleChange}
            onBlur={formHandler.handleBlur}
            isInvalid={!!formHandler.errors.username && formHandler.touched.username}
            autoComplete='username'
            id='username'
          />
          <Row>
            <Col>
              {
                !!formHandler.errors.username && formHandler.touched.username && (
                  <Form.Text className='text-danger'>
                    {formHandler.errors.username}
                  </Form.Text>
                )
              }
            </Col>
            <Col className='text-end'>
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault()
                  openForgotModal('Username')
                }}
                className='small'
              >
                Forgot Username?
              </Link>
            </Col>
          </Row>
        </Form.Group>
        <Form.Group className='custom'>
          <Form.Label htmlFor='password'>
            Password:
          </Form.Label>
          <PasswordInput
            id='password'
            showPassword={showPassword}
            placeholder='Enter Password'
            name='password'
            value={formHandler.values.password}
            handleChange={formHandler.handleChange}
            handleBlur={formHandler.handleBlur}
            isInvalid={!!formHandler.errors.password && formHandler.touched.password}
            toggleShowPassword={() => setShowPassword(!showPassword)}
            autoComplete='current-password'
          />
          <Row>
            <Col>
              {
                !!formHandler.errors.password && formHandler.touched.password && (
                  <Form.Text className='text-danger'>
                    {formHandler.errors.password}
                  </Form.Text>
                )
              }
            </Col>
            <Col className='text-end'>
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault()
                  openForgotModal('Password')
                }}
                className='small'
              >
                Forgot Password?
              </Link>
            </Col>
          </Row>
        </Form.Group>
        <div>
          {!isLoading ?
            <Button type='submit' variant='primary'>Log In</Button>
            :
            <Button type='submit' variant='primary' disabled={isLoading}>
              <FhirLoader small={true} />
            </Button>
          }
        </div>
      </Form>
    </>
  )
}

export default LoginForm